import React, { Fragment } from "react";
import './App.css';

const Education = ()=>{
    return (
    <div className="educationChild">
        <h2>03_EDUCATION</h2>
      <p>
          <u><b>Formal:</b></u>
        <br /><b>Diponegoro University, Semarang</b>
        <br />International Law
        <br />2012
        <br /><br />
          <u><b>Non-formal:</b></u>
        <br/><b>Impact Byte, Jakarta</b>
        <br />Full Stack JavaScript Bootcamp
        <br/>2020
        <br /><br />
        <b>Hacktiv8, Jakarta</b>
        <br />Intro to Programming Class
        <br /> 2019
        <br /><br />
        <b>Kukche Languange, Bogor</b>
        <br />Basic Japanese Languange
        <br />2017
        <br /><br />
        <b>RED DJ School, Semarang</b>
        <br />Club Mix Class
        <br />2012
      </p>
    </div>
    );
};

export default Education